<div [ngClass]="starClasses[0]"></div>
<div [ngClass]="starClasses[1]"></div>
<div [ngClass]="starClasses[2]"></div>
<div [ngClass]="starClasses[3]"></div>
<div [ngClass]="starClasses[4]"></div>
